import { extend } from 'vee-validate';

import { isPasswordValid } from '@/core/rules';

extend('password', isPasswordValid);
